import Axios from 'axios';
import store from '@/store';
import router from '@/router';
import { env } from '@/helpers/env';
import { LOGIN } from '@/router/routes.names';

const api = Axios.create({
  baseURL: env.VUE_APP_API_URL,
});

api.interceptors.request.use((config) => {
  if (store.getters['auth/isLogged']) {
    // eslint-disable-next-line
    config.headers.common['Authorization'] = `Bearer ${store.state.auth.authToken.access_token}`;

    return config;
  }

  return config;
});

api.interceptors.response.use(null, (error) => {
  if (error.response) {
    if (error.response.status === 401) {
      store.commit('auth/clearAuth');
      router.push({
        name: LOGIN,
      });
    }
  }

  return Promise.reject(error);
});

export default api;
